/** Add/Edit Medication form strings. */

const mk = (values) => values;

export const MEDICATION_FORM_LOCALE_BLOCKS = {
  hi: mk({
    addMedication: "दवा जोड़ें",
    updateMedication: "दवा अपडेट करें",
    medicationInfo: "दवा जानकारी",
    dosageSchedule: "खुराक और शेड्यूल",
    scheduleType: "शेड्यूल प्रकार",
    dateRange: "तिथि सीमा",
    multipleDates: "कई तिथियां",
    searchMedication: "दवा खोजें और चुनें",
    selectMedicationFirst: "पहले दवा चुनें",
    type: "प्रकार",
    frequency: "आवृत्ति",
    quantityDosage: "मात्रा/खुराक",
    enterManually: "मैन्युअल दर्ज करें",
    selectFromList: "सूची से चुनें...",
    noListAvailable: "कोई सूची उपलब्ध नहीं",
    enterQuantity: "मात्रा दर्ज करें",
    unit: "इकाई",
    startDate: "प्रारंभ तिथि",
    endDate: "समाप्ति तिथि",
    selectStartDate: "प्रारंभ तिथि चुनें",
    selectEndDate: "समाप्ति तिथि चुनें",
    selectMultipleDates: "कई तिथियां चुनें",
    additionalNotes: "अतिरिक्त नोट्स",
    enterAdditionalNotes: "अतिरिक्त नोट्स दर्ज करें",
    addMedicine: "दवा जोड़ें",
    updateMedicine: "दवा अपडेट करें",
    saveAllMedications: "सभी दवाएं सहेजें",
    saving: "सहेजा जा रहा है...",
    medicationNameRequired: "दवा का नाम आवश्यक है",
    typeRequired: "प्रकार आवश्यक है",
    frequencyRequired: "आवृत्ति आवश्यक है",
    startDateRequired: "प्रारंभ तिथि आवश्यक है",
    endDateRequired: "समाप्ति तिथि आवश्यक है",
    endDateAfterStart: "समाप्ति तिथि प्रारंभ तिथि के बाद या उसी दिन होनी चाहिए",
    selectTimeSlot: "कम से कम एक समय स्लॉट चुनें (सुबह, दोपहर, शाम या रात)।",
    quantityDosageRequired: "मात्रा/खुराक आवश्यक है",
    selectTime: "समय चुनें",
    quantity: "मात्रा",
    beforeMeal: "भोजन से पहले",
    afterMeal: "भोजन के बाद",
    morning: "सुबह",
    noon: "दोपहर",
    evening: "शाम",
    night: "रात",
    medicine: "दवा",
    times: "समय",
    schedule: "शेड्यूल",
    action: "कार्रवाई",
    medicineAdded: "दवा सफलतापूर्वक जोड़ी गई",
    medicineUpdated: "दवा सफलतापूर्वक अपडेट हुई",
    selectAtLeastOneDate: "कृपया कम से कम एक तिथि चुनें",
    addAtLeastOneMedication: "कृपया कम से कम एक दवा जोड़ें",
    fixSlotErrors: "चयनित स्लॉट के लिए समय और मात्रा ठीक करें।",
  }),
  pa: mk({
    addMedication: "ਦਵਾਈ ਜੋੜੋ",
    medicationInfo: "ਦਵਾਈ ਜਾਣਕਾਰੀ",
    dosageSchedule: "ਖੁਰਾਕ ਅਤੇ ਸ਼ੈਡਿਊਲ",
    scheduleType: "ਸ਼ੈਡਿਊਲ ਕਿਸਮ",
    dateRange: "ਤਾਰੀਖ ਸੀਮਾ",
    multipleDates: "ਕਈ ਤਾਰੀਖਾਂ",
    searchMedication: "ਦਵਾਈ ਖੋਜੋ ਅਤੇ ਚੁਣੋ",
    selectMedicationFirst: "ਪਹਿਲਾਂ ਦਵਾਈ ਚੁਣੋ",
    quantityDosage: "ਮਾਤਰਾ/ਖੁਰਾਕ",
    enterManually: "ਹੱਥੀਂ ਦਰਜ ਕਰੋ",
    selectFromList: "ਸੂਚੀ ਤੋਂ ਚੁਣੋ...",
    noListAvailable: "ਕੋਈ ਸੂਚੀ ਉਪਲਬਧ ਨਹੀਂ",
    enterQuantity: "ਮਾਤਰਾ ਦਰਜ ਕਰੋ",
    addMedicine: "ਦਵਾਈ ਜੋੜੋ",
    updateMedicine: "ਦਵਾਈ ਅਪਡੇਟ ਕਰੋ",
    startDateRequired: "ਸ਼ੁਰੂਆਤੀ ਤਾਰੀਖ ਲੋੜੀਂਦੀ ਹੈ",
    endDateRequired: "ਸਮਾਪਤੀ ਤਾਰੀਖ ਲੋੜੀਂਦੀ ਹੈ",
    selectTimeSlot: "ਘੱਟੋ-ਘੱਟ ਇੱਕ ਸਮਾਂ ਸਲਾਟ ਚੁਣੋ।",
    morning: "ਸਵੇਰ",
    noon: "ਦੁਪਹਿਰ",
    evening: "ਸ਼ਾਮ",
    night: "ਰਾਤ",
  }),
  te: mk({
    addMedication: "మందు జోడించండి",
    medicationInfo: "మందు సమాచారం",
    dosageSchedule: "మోతాదు & షెడ్యూల్",
    scheduleType: "షెడ్యూల్ రకం",
    dateRange: "తేదీ పరిధి",
    multipleDates: "అనేక తేదీలు",
    searchMedication: "మందు వెతకండి మరియు ఎంచుకోండి",
    selectMedicationFirst: "ముందు మందు ఎంచుకోండి",
    quantityDosage: "పరిమాణం/మోతాదు",
    enterManually: "మాన్యువల్‌గా నమోదు చేయండి",
    selectFromList: "జాబితా నుండి ఎంచుకోండి...",
    noListAvailable: "జాబితా అందుబాటులో లేదు",
    enterQuantity: "పరిమాణం నమోదు చేయండి",
    addMedicine: "మందు జోడించండి",
    updateMedicine: "మందు అప్‌డేట్ చేయండి",
    startDateRequired: "ప్రారంభ తేదీ అవసరం",
    endDateRequired: "ముగింపు తేదీ అవసరం",
    selectTimeSlot: "కనీసం ఒక సమయ స్లాట్ ఎంచుకోండి.",
    morning: "ఉదయం",
    noon: "మధ్యాహ్నం",
    evening: "సాయంత్రం",
    night: "రాత్రి",
  }),
  ta: mk({
    addMedication: "மருந்து சேர்",
    medicationInfo: "மருந்து தகவல்",
    dosageSchedule: "அளவு & அட்டவணை",
    scheduleType: "அட்டவணை வகை",
    dateRange: "தேதி வரம்பு",
    multipleDates: "பல தேதிகள்",
    searchMedication: "மருந்தைத் தேடி தேர்ந்தெடுக்கவும்",
    selectMedicationFirst: "முதலில் மருந்தைத் தேர்ந்தெடுக்கவும்",
    quantityDosage: "அளவு/மருந்தளவு",
    enterManually: "கைமுறையாக உள்ளிடவும்",
    selectFromList: "பட்டியலிலிருந்து தேர்ந்தெடுக்கவும்...",
    noListAvailable: "பட்டியல் இல்லை",
    enterQuantity: "அளவை உள்ளிடவும்",
    addMedicine: "மருந்து சேர்",
    updateMedicine: "மருந்து புதுப்பி",
    startDateRequired: "தொடக்க தேதி தேவை",
    endDateRequired: "முடிவு தேதி தேவை",
    selectTimeSlot: "குறைந்தது ஒரு நேர இடைவெளியைத் தேர்ந்தெடுக்கவும்.",
    morning: "காலை",
    noon: "மதியம்",
    evening: "மாலை",
    night: "இரவு",
  }),
  mr: mk({
    addMedication: "औषध जोडा",
    medicationInfo: "औषध माहिती",
    dosageSchedule: "डोस आणि वेळापत्रक",
    scheduleType: "वेळापत्रक प्रकार",
    dateRange: "तारीख श्रेणी",
    multipleDates: "अनेक तारखा",
    searchMedication: "औषध शोधा आणि निवडा",
    selectMedicationFirst: "प्रथम औषध निवडा",
    quantityDosage: "प्रमाण/डोस",
    enterManually: "स्वहस्ते प्रविष्ट करा",
    selectFromList: "यादीतून निवडा...",
    noListAvailable: "यादी उपलब्ध नाही",
    enterQuantity: "प्रमाण प्रविष्ट करा",
    addMedicine: "औषध जोडा",
    updateMedicine: "औषध अपडेट करा",
    startDateRequired: "प्रारंभ तारीख आवश्यक आहे",
    endDateRequired: "समाप्ती तारीख आवश्यक आहे",
    selectTimeSlot: "किमान एक वेळ स्लॉट निवडा.",
    morning: "सकाळ",
    noon: "दुपार",
    evening: "संध्याकाळ",
    night: "रात्र",
  }),
  bn: mk({
    addMedication: "ওষুধ যোগ করুন",
    medicationInfo: "ওষুধের তথ্য",
    dosageSchedule: "ডোজ ও সময়সূচী",
    scheduleType: "সময়সূচীর ধরন",
    dateRange: "তারিখের পরিসর",
    multipleDates: "একাধিক তারিখ",
    searchMedication: "ওষুধ খুঁজুন এবং নির্বাচন করুন",
    selectMedicationFirst: "প্রথমে ওষুধ নির্বাচন করুন",
    quantityDosage: "পরিমাণ/ডোজ",
    enterManually: "ম্যানুয়ালি লিখুন",
    selectFromList: "তালিকা থেকে নির্বাচন করুন...",
    noListAvailable: "কোনো তালিকা নেই",
    enterQuantity: "পরিমাণ লিখুন",
    addMedicine: "ওষুধ যোগ করুন",
    updateMedicine: "ওষুধ আপডেট করুন",
    startDateRequired: "শুরুর তারিখ প্রয়োজন",
    endDateRequired: "শেষ তারিখ প্রয়োজন",
    selectTimeSlot: "অন্তত একটি সময় স্লট নির্বাচন করুন।",
    morning: "সকাল",
    noon: "দুপুর",
    evening: "সন্ধ্যা",
    night: "রাত",
  }),
  kn: mk({
    addMedication: "ಔಷಧಿ ಸೇರಿಸಿ",
    medicationInfo: "ಔಷಧಿ ಮಾಹಿತಿ",
    dosageSchedule: "ಡೋಸ್ & ವೇಳಾಪಟ್ಟಿ",
    scheduleType: "ವೇಳಾಪಟ್ಟಿ ಪ್ರಕಾರ",
    dateRange: "ದಿನಾಂಕ ಶ್ರೇಣಿ",
    multipleDates: "ಹಲವು ದಿನಾಂಕಗಳು",
    searchMedication: "ಔಷಧಿ ಹುಡುಕಿ ಆಯ್ಕೆಮಾಡಿ",
    selectMedicationFirst: "ಮೊದಲು ಔಷಧಿ ಆಯ್ಕೆಮಾಡಿ",
    quantityDosage: "ಪ್ರಮಾಣ/ಡೋಸ್",
    enterManually: "ಕೈಯಾರೆ ನಮೂದಿಸಿ",
    selectFromList: "ಪಟ್ಟಿಯಿಂದ ಆಯ್ಕೆಮಾಡಿ...",
    noListAvailable: "ಪಟ್ಟಿ ಲಭ್ಯವಿಲ್ಲ",
    enterQuantity: "ಪ್ರಮಾಣ ನಮೂದಿಸಿ",
    addMedicine: "ಔಷಧಿ ಸೇರಿಸಿ",
    updateMedicine: "ಔಷಧಿ ಅಪ್‌ಡೇಟ್ ಮಾಡಿ",
    startDateRequired: "ಪ್ರಾರಂಭ ದಿನಾಂಕ ಅಗತ್ಯ",
    endDateRequired: "ಅಂತ್ಯ ದಿನಾಂಕ ಅಗತ್ಯ",
    selectTimeSlot: "ಕನಿಷ್ಠ ಒಂದು ಸಮಯ ಸ್ಲಾಟ್ ಆಯ್ಕೆಮಾಡಿ.",
    morning: "ಬೆಳಿಗ್ಗೆ",
    noon: "ಮಧ್ಯಾಹ್ನ",
    evening: "ಸಂಜೆ",
    night: "ರಾತ್ರಿ",
  }),
};

export const applyMedicationFormLocaleBlocks = (translations) => {
  if (!translations.en?.medicationForm) {
    translations.en.medicationForm = {
      addMedication: "Add Medication",
      updateMedication: "Update Medication",
      medicationInfo: "Medication Info",
      dosageSchedule: "Dosage & Schedule",
      scheduleType: "Schedule Type",
      dateRange: "Date Range",
      multipleDates: "Multiple Dates",
      searchMedication: "Search and select medication",
      selectMedicationFirst: "Select medication first",
      type: "Type",
      frequency: "Frequency",
      quantityDosage: "Select Quantity/Dosage",
      enterManually: "Or Enter Manually",
      selectFromList: "Select from list...",
      noListAvailable: "No list available",
      enterQuantity: "Enter quantity",
      unit: "Unit",
      startDate: "Start Date",
      endDate: "End Date",
      selectStartDate: "Select start date",
      selectEndDate: "Select end date",
      selectMultipleDates: "Select multiple dates",
      additionalNotes: "Additional Notes",
      enterAdditionalNotes: "Enter Additional Notes",
      addMedicine: "Add Medicine",
      updateMedicine: "Update Medicine",
      saveAllMedications: "Save All Medications",
      saving: "Saving...",
      medicationNameRequired: "Medication name is required",
      typeRequired: "Type is required",
      frequencyRequired: "Frequency is required",
      startDateRequired: "Start date is required",
      endDateRequired: "End date is required",
      endDateAfterStart: "End date must be on or after start date",
      selectTimeSlot:
        "Select at least one time slot (Morning, Noon, Evening, or Night).",
      quantityDosageRequired: "Quantity/Dosage is required",
      selectTime: "Select time",
      quantity: "Quantity",
      beforeMeal: "Before Meal",
      afterMeal: "After Meal",
      morning: "Morning",
      noon: "Noon",
      evening: "Evening",
      night: "Night",
      medicine: "Medicine",
      times: "Times",
      schedule: "Schedule",
      action: "Action",
      medicineAdded: "Medicine added successfully",
      medicineUpdated: "Medicine updated successfully",
      selectAtLeastOneDate: "Please select at least one date",
      addAtLeastOneMedication: "Please add at least one medication",
      fixSlotErrors: "Please fix time and quantity for each selected slot.",
    };
  }
  Object.entries(MEDICATION_FORM_LOCALE_BLOCKS).forEach(([lang, values]) => {
    if (!translations[lang]) return;
    translations[lang].medicationForm = {
      ...translations.en.medicationForm,
      ...translations[lang].medicationForm,
      ...values,
    };
  });
};
